import React, { useState, useEffect, useRef } from "react";
import { Search, Menu, X, ChevronDown, ArrowRight } from "lucide-react";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeMobileSub, setActiveMobileSub] = useState(null);
  const searchInputRef = useRef(null);

  const menuData = [
    { title: "Home", path: "/", type: "link" },
    {
      title: "About Us",
      type: "dropdown",
      links: [
        { label: "Who are we", path: "/about-us/who-are-we" },
        {
          label: "Customer Service Charter",
          path: "/about-us/customer-service-charter",
        },
        { label: "Our Leadership", path: "/about-us/our-leadership" },
      ],
    },
    { title: "Products", path: "/products", type: "link" },
    { title: "Contact", path: "/contact", type: "link" },
  ];

  useEffect(() => {
    if (isSearchOpen) {
      setTimeout(() => searchInputRef.current?.focus(), 100);
    }
  }, [isSearchOpen]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar-header ${isScrolled ? "scrolled" : ""}`}>
      <div className={`search-overlay ${isSearchOpen ? "active" : ""}`}>
        <div className="search-container">
          <Search size={20} className="search-icon-inside" />
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search insurance..."
            className="search-input-field"
          />
          <button
            className="search-close"
            onClick={() => setIsSearchOpen(false)}
          >
            <X size={24} />
          </button>
        </div>
      </div>

      <div className="container nav-content">
        <div className="branding">
          <img
            src="https://res.cloudinary.com/dxgkcyfrl/image/upload/v1767593282/logo1_ssbtzf.png"
            alt="Rift Nakuru"
            className="logo-img"
          />
        </div>

        <nav className="desktop-nav">
          <ul className="nav-menu">
            {menuData.map((item, idx) =>
              item.type === "dropdown" ? (
                <li key={idx} className="nav-dropdown-wrapper">
                  <a href="/" className="nav-link">
                    {item.title} <ChevronDown size={14} className="chevron" />
                  </a>
                  <div className="dropdown-panel">
                    <div className="dropdown-inner">
                      {item.links.map((sub, sIdx) => (
                        <a key={sIdx} href={sub.path}>
                          {sub.label} <ArrowRight size={14} />
                        </a>
                      ))}
                    </div>
                  </div>
                </li>
              ) : (
                <li key={idx}>
                  <a href={item.path} className="nav-link">
                    {item.title}
                  </a>
                </li>
              )
            )}
            <li>
              <a href="/quote" className="btn-action">
                Get a Quote
              </a>
            </li>
          </ul>
        </nav>

        <div className="nav-util">
          <button className="icon-btn" onClick={() => setIsSearchOpen(true)}>
            <Search size={22} />
          </button>
          <button className="mobile-toggle" onClick={() => setIsMenuOpen(true)}>
            <Menu size={28} />
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-overlay ${isMenuOpen ? "open" : ""}`}>
        <div className="mobile-header-actions">
          <img
            src="https://res.cloudinary.com/dxgkcyfrl/image/upload/v1767593282/logo1_ssbtzf.png"
            alt="Logo"
            className="mobile-logo-small"
          />
          <button className="close-btn" onClick={() => setIsMenuOpen(false)}>
            <X size={32} />
          </button>
        </div>
        <ul className="mobile-nav-links">
          {menuData.map((item, idx) =>
            item.type === "dropdown" ? (
              <li
                key={idx}
                className={activeMobileSub === idx ? "expanded" : ""}
              >
                <button
                  className="sub-trigger"
                  onClick={() =>
                    setActiveMobileSub(activeMobileSub === idx ? null : idx)
                  }
                >
                  {item.title} <ChevronDown size={20} className="mob-chevron" />
                </button>
                <div className="mobile-submenu">
                  {item.links.map((sub, sIdx) => (
                    <a
                      key={sIdx}
                      href={sub.path}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {sub.label}
                    </a>
                  ))}
                </div>
              </li>
            ) : (
              <li key={idx}>
                <a href={item.path} onClick={() => setIsMenuOpen(false)}>
                  {item.title}
                </a>
              </li>
            )
          )}
          <li>
            <a
              href="/quote"
              className="mobile-cta"
              onClick={() => setIsMenuOpen(false)}
            >
              Get a Quote
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
